/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

export default class HeaderAlert extends Component {
  role = 'alert';
}
